import React, { useEffect, useState } from 'react'
import queryString from 'query-string'
import GoogleMap from '@molecules/GoogleMap/GoogleMap'
import {
  DHLPackstationMapProps,
  FindByGeoParams,
  DhlPackstationAddress
} from './DHLPackstationMap.types'
import { GoogleMapMarker } from '@molecules/GoogleMap/GoogleMap.types'

const DHLPackstationMap = ({
  className,
  addressFinderInput,
  DHLApiKey,
  DHLApiUrl,
  GoogleMapApiKey,
  defaultDHLParams,
  onPackstationSelect,
  infoView,
  packstationIcon
}: DHLPackstationMapProps) => {
  const [autocomplete, setAutocomplete] =
    useState<google.maps.places.Autocomplete>()
  const [selectedLocation, setSelectedLocation] =
    useState<google.maps.LatLngLiteral>()
  const [markers, setMarkers] = useState<GoogleMapMarker[]>([])
  const defaultQueryParams: FindByGeoParams = defaultDHLParams
  const markerIcon: google.maps.Icon = {
    url: `data:image/svg+xml;utf8,${packstationIcon}`
  }

  let initialZoom = 5

  const requestOptions = {
    method: 'GET',
    headers: { 'DHL-API-Key': DHLApiKey }
  }

  const onLoad = (autocomplete: google.maps.places.Autocomplete) => {
    setAutocomplete(autocomplete)
  }

  const onMarkerClick = (packstation: object) => {
    onPackstationSelect && onPackstationSelect(packstation)
  }

  const onPlaceChanged = () => {
    if (autocomplete?.getPlace().geometry?.location) {
      const location = autocomplete.getPlace().geometry?.location

      if (location) {
        setSelectedLocation({
          lat: location.lat() || 0,
          lng: location.lng() || 0
        })
        initialZoom = 13
      }
    }
  }

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position: GeolocationPosition) => {
        setSelectedLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude
        })
      }
    )
  }, [])

  useEffect(() => {
    const abortController = new AbortController()

    if (selectedLocation) {
      defaultQueryParams.latitude = selectedLocation.lat
      defaultQueryParams.longitude = selectedLocation.lng
      defaultQueryParams.countryCode = 'DE'

      fetch(
        `${DHLApiUrl}/find-by-geo?${queryString.stringify(defaultQueryParams)}`,
        requestOptions
      )
        .then((response) => !abortController.signal.aborted && response.json())
        .then((response) => {
          if (!abortController.signal.aborted) {
            const locations: GoogleMapMarker[] = [
              {
                id: 'searched_address',
                position: {
                  lat: selectedLocation.lat,
                  lng: selectedLocation.lng
                }
              }
            ]

            response?.locations?.map((packstation: any) => {
              const packstationData: DhlPackstationAddress = {
                name: packstation.name,
                distance: packstation.distance,
                streetAddress: packstation.place?.address?.streetAddress,
                packstationKeyword: packstation.location?.keyword,
                packstationNumber: packstation.location?.keywordId,
                country: packstation.place?.address?.countryCode,
                city: packstation.place?.address?.addressLocality,
                postalCode: packstation.place?.address?.postalCode,
                type: packstation.location?.type
              }

              const location: GoogleMapMarker = {
                id: packstation.location?.ids?.[0]?.locationId,
                position: {
                  lat: packstation.place?.geo?.latitude,
                  lng: packstation.place?.geo?.longitude
                },
                data: packstationData
              }

              if (packstationIcon) {
                location.icon = markerIcon
              }

              locations.push(location)
            })
            setMarkers(locations)
          }
        })
        .catch(() => setMarkers([]))
    }

    return () => abortController.abort()
  }, [selectedLocation])

  return (
    <div className={className}>
      <GoogleMap
        className={className}
        autoCompleteInput={addressFinderInput}
        onAutoCompleteLoad={onLoad}
        onAutoCompletePlaceChanged={onPlaceChanged}
        APIkey={GoogleMapApiKey}
        initialCenter={
          selectedLocation || {
            lat: defaultQueryParams.latitude,
            lng: defaultQueryParams.longitude
          }
        }
        infoView={infoView}
        initialZoom={initialZoom}
        marks={markers}
        onMarkerClick={onMarkerClick}
      />
    </div>
  )
}

export default DHLPackstationMap
